module.exports = __WEBPACK_EXTERNAL_MODULE_json_websiteConfig__;